import moment from "moment";
export const removeSlashes = (path) => {
  return path.startsWith("/")
    ? path
        .split("/")
        .filter((x) => x !== "")
        .join("/")
    : path;
};

export const formatDateFull = (date) => {
  if (!date) return '-'
  const dateToFormat = new Date(date)
  if (Number.isNaN(dateToFormat.getTime())) return '-'
  const options = {
    year: "numeric",
    month: "long",
    day: "numeric",
    weekday: "long",
  };
  return dateToFormat.toLocaleDateString("en-GB", options);
};

export const isDateWithinRange = (dateValue, start, end) => {
  if (!start || !end) return true
  if (!dateValue) return false
  const parsed = new Date(dateValue)
  if (Number.isNaN(parsed.getTime())) return false
  const d = new Date(parsed.getFullYear(), parsed.getMonth(), parsed.getDate())
  const s = new Date(start.getFullYear(), start.getMonth(), start.getDate())
  const e = new Date(end.getFullYear(), end.getMonth(), end.getDate())
  return d >= s && d <= e
}

export const formatScheduledPublishDate = (date) => {
  if (!date) return '-'
  const parsed = new Date(date)
  if (Number.isNaN(parsed.getTime())) return '-'
  return parsed.toLocaleString('en-GB', {
    weekday: 'short',
    day: 'numeric',
    month: 'short',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  })
}

function padTo2Digits(num) {
  return String(num).padStart(2, "0");
}

export const GetTimeFromDate = (date) => {
  const mydate = new Date(date);
  const hoursAndMinutes =
    padTo2Digits(mydate.getHours()) + ":" + padTo2Digits(mydate.getMinutes());

  return hoursAndMinutes;
};

export const createID = (length) => {
  var result = "";
  var characters = "0123456789";
  var charactersLength = characters.length;
  for (var i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
};

export function formatMydate() {
  let now = new Date();
  let day = now.getDate();

  let month = now.getMonth() + 1;

  let year = now.getFullYear().toString();
  
  let result = year.substring(2, 4);

  let mins=parseInt(now.getMinutes()+1)

  let time = now.getHours() + ":" + mins.toString();

  let formatted_time = month + "/" + day + "/" + result + " " + time;

  return formatted_time;
}


export function formatdateForSchedule(data) {
 
 
  let tdate=new Date(data)


  let day = tdate.getDate();

  let month = tdate.getMonth() + 1;

  let year = tdate.getFullYear().toString();
  
  let result = year.substring(2, 4);

  let formatted_time = month + "/" + day + "/" + result 

  return formatted_time;
}

export const PASSWORD_VALIDATION_MESSAGE =
  'Password must contain at least one uppercase letter, one lowercase letter, and at least one number or special character'

export const hasNumberOrSpecialChar = (password = '') =>
  /[0-9]/.test(password) || /[^A-Za-z0-9]/.test(password)

export const isPasswordValid = (password = '') =>
  password.length >= 8 &&
  /[A-Z]/.test(password) &&
  /[a-z]/.test(password) &&
  hasNumberOrSpecialChar(password)

export const PASSWORDRULES = [
  {
    label: "Minimum of 8 characters",
    test: (pw) => pw.length >= 8,
  },
  {
    label: "At least one uppercase letter",
    test: (pw) => /[A-Z]/.test(pw),
  },
  {
    label: "At least one lowercase letter",
    test: (pw) => /[a-z]/.test(pw),
  },
  {
    label: "At least one number or special character",
    test: (pw) => hasNumberOrSpecialChar(pw),
  },
]